import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
    title: 'Credlix Blogs',
    url: WEB_URL+'/es-mx/blogs',
    description:'Lista de blogs en Credlix',
    keyword: 'financiamiento de cadena de suministro, financiamiento de cadena de suministro en México, cadena de suministro en finanzas, compañía de financiamiento de cadena de suministro', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
},
 authorData: {
   authorTitle: "Autora",
   authorName: "Team Credlix",
   authorBioName: 'Acerca del Team Credlix',
   authorBioTitle: "Biografía del autor",
   authorBio: 'Team Credlix es el equipo editorial detrás de Credlix, una plataforma digital global de financiamiento para el comercio. El equipo escribe sobre financiamiento a las exportaciones, financiamiento de la cadena de suministro y capital de trabajo, aportando conocimientos prácticos de las MiPyMEs, exportadores y mercados de comercio global, con un enfoque especial en empresas que operan en México, para simplificar decisiones financieras complejas.',
   viewProfile: "Ver perfil",  
   authorH2: "Blogs de este autor",
   breadCreumbPageTitle: "Blog Autor",
 },
 blogviewData: {
  blogView: "Vistas",
  blogRead: "min",
},
}